import AchievementChip from './AchievementChip'
import ChoiceChip from './ChoiceChip'
import FilterChip from './FilterChip'

// TO-DO: check type
const Chip = {
  Choice: ChoiceChip,
  Filter: FilterChip,
  Achievement: AchievementChip,
}

export default Chip
